import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import Media from 'react-media';
import Modal from '../LazyWidgets/Modal';
import Table from '../LazyWidgets/Table';
import Pagination from '../LazyWidgets/Pagination';
import MiniTable from '../LazyWidgets/MiniTable';
import Spinner from '../LazyWidgets/Spinner';
import CollapsibleCard from '../CollapsibleCard';
import s from './PaginatedTable.module.css';
import MLIcon from '../MLIcon/MLIcon';
import { normalizeString } from '../../src/ReportsTabs/utils';


class PaginatedTable extends Component {
  static propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string,
    data: PropTypes.array,
    course: PropTypes.object,
    modalContent: PropTypes.object,
    tableStyle: PropTypes.array,
    tableColumns: PropTypes.array,
    sortBy: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    direction: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    nullState: PropTypes.object,
    styleFunction: PropTypes.func,
    tableMinWidth: PropTypes.number,
    loading: PropTypes.bool,
    onColumnChange: PropTypes.func,
    reportType: PropTypes.string,
    caretColor: PropTypes.string,
    collapsible: PropTypes.bool,
    customSort: PropTypes.func,
    customSortBy: PropTypes.string,
  };

  static defaultProps = {
    id: '',
    className: '',
    title: '',
    data: [],
    course: {},
    modalContent: {},
    tableStyle: [],
    tableColumns: [],
    sortBy: '',
    direction: 'asc',
    nullState: {},
    tableMinWidth: 555,
    loading: false,
    caretColor: '#000',
    customSortBy: '',
  };

  static sortPaginatedTable(data, sortBy, direction) {
    return _.orderBy(data, sortBy, direction);
  }

  static newTable(props, sortBy, direction, styleFunction) {
    if (props && props.length > 0) {
      const newDataTable = props.map((item) => {
        const newItem = { ...item };
        if (styleFunction) { newItem.className = styleFunction(item); }
        return newItem;
      });
      return PaginatedTable.sortPaginatedTable(newDataTable, sortBy, direction);
    }
    return null;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!_.isEqual(nextProps.data, prevState.data)) {
      const data = PaginatedTable.newTable(nextProps.data, prevState.defaultOrder.sortBy, prevState.defaultOrder.direction, nextProps.styleFunction);
      return ({
        data: nextProps.data,
        tableData: data,
        tablePaginated: data ? data.slice(0, prevState.pageSize) : null,
        sortBy: prevState.defaultOrder.sortBy,
        direction: prevState.defaultOrder.direction,
        paginatedActivePage: 1,
      });
    }
    return null;
  }

  constructor(props) {
    super(props);
    const { tableStyle, tableColumns, sortBy, direction, data, styleFunction } = props;
    const pageSize = 10;
    this.paginate = this.paginate.bind(this);
    this.tableSort = this.tableSort.bind(this);
    const defaultOrder = {
      sortBy,
      direction,
    };

    const newData = PaginatedTable.newTable(data, sortBy, direction, styleFunction);

    this.state = {
      data: props.data,
      defaultOrder,
      filterTerm: '',
      pageSize,
      tableStyle,
      tableColumns,
      tableData: newData,
      tablePaginated: newData ? newData.slice(0, pageSize) : null,
      sortBy: Array.isArray(sortBy) ? sortBy[0] : sortBy,
      direction,
      paginatedActivePage: 1,
    };
    this.refContainer = React.createRef();
    this.adjustDropDowns = this.adjustDropDowns.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  componentDidMount() {
    this.adjustDropDowns();
  }

  getPaginationComponent(boundary) {
    return (
      <Pagination
        className={s.paginator}
        activePage={this.state.paginatedActivePage}
        boundaryRange={boundary}
        onPageChange={this.paginate}
        totalPages={Math.ceil(this.state.tableData.length / this.state.pageSize)}
        siblingRange={0}
        firstItem={null}
        lastItem={null}
        defaultActivePage={1}
      />
    );
  }

  getModalComponent() {
    return (
      <Modal
        className={s.qqPerformanceModalContainer}
        trigger={
          <div>
            <button className={s.howLink} role="link">
              How is this calculated?
            </button>
          </div>}
      >
        <Modal.Header>
          <p className={s.qqPerformanceModalHeader}>{this.props.title}</p>
        </Modal.Header>
        <Modal.Content id="my-modal-id" className={s.qqPerformanceModalContent}>
          {this.props.modalContent}
        </Modal.Content>
      </Modal>
    );
  }

  adjustDropDowns() {
    if (this.props.onColumnChange) {
      this.props.onColumnChange();
    }
    if (this.refContainer.current) {
      const dropDowns = this.refContainer.current.getElementsByTagName('select');
      for (const dropDown of dropDowns) {
        const fakeWidth = this.calculateFakeWidth(dropDown.options[dropDown.selectedIndex].textContent);
        if (fakeWidth > dropDown.offsetWidth + 3) {
          dropDown.parentElement.classList.add(s.ellipsis);
        } else {
          dropDown.parentElement.classList.remove(s.ellipsis);
        }
      }
    }
  }

  calculateFakeWidth(text) {
    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);
    tempDiv.style.fontSize = '17px';
    tempDiv.style.position = 'absolute';
    tempDiv.style.left = -1000;
    tempDiv.style.top = -1000;
    tempDiv.style['white-space'] = 'nowrap';
    tempDiv.style.lineHeight = '32px';
    tempDiv.innerHTML = text;
    const width = tempDiv.clientWidth;
    document.body.removeChild(tempDiv);
    return width;
  }

  paginate(e, obj) {
    const start = (obj.activePage - 1) * this.state.pageSize;
    const end = start + this.state.pageSize;
    this.setState({
      tablePaginated: this.state.tableData.slice(start, end),
      paginatedActivePage: obj.activePage,
    });
  }

  tableSort(e, order) {
    const newTable = order.column === this.props.customSortBy
      ? this.props.customSort(this.state.tableData, order.direction)
      : PaginatedTable.sortPaginatedTable(this.state.tableData, order.column, order.direction);
    let filteredTable = [...newTable];

    if (this.state.filterTerm) {
      filteredTable = _.filter(newTable, (item) =>
        normalizeString(item.name.toLowerCase()).includes(normalizeString(this.state.filterTerm.toLowerCase()))
      );
    }

    this.setState({
      sortBy: order.column,
      direction: order.direction,
      tableData: newTable,
      tablePaginated: filteredTable.slice(0, this.state.pageSize),
      paginatedActivePage: 1,
    });
  }

  handleFilterChange(event) {
    const filterTerm = event.target?.value;
    if (!filterTerm) {
        return this.setState({
          filterTerm: '',
          tablePaginated: this.state.tableData.slice(this.state.paginatedActivePage - 1, this.state.pageSize),
        });
    }

    const filteredData = _.filter(this.state.tableData, (item) =>
      normalizeString(item.name.toLowerCase()).includes(normalizeString(filterTerm.toLowerCase()))
    );

    const start = (this.state.paginatedActivePage - 1) * this.state.pageSize;
    const end = start + this.state.pageSize;
    const paginatedFilteredData = filteredData.slice(start, end);

    return this.setState({
      filterTerm,
      tablePaginated: paginatedFilteredData,
      paginatedActivePage: 1,
    });
  }

  miniTableColumns() {
    const avg = _.find(this.state.tableColumns, ['accessor', Array.isArray(this.props.sortBy) ? this.props.sortBy[0] : this.props.sortBy]);
    const mini = [...this.state.tableColumns];
    const indexToRemove = mini.indexOf(avg);
    mini.splice(indexToRemove, 1);
    mini.splice(1, 0, avg);
    return mini;
  }

  render() {
    const { id, loading, reportType, className = '', collapsible } = this.props;
    return (
      <CollapsibleCard id={id} title={this.props.title} collapsible={collapsible} className={className} reportType={reportType}>
        {!loading && this.state.tableData &&
        <Media query={{ minWidth: 710 }}>
          {matches =>
                (matches ? (
                  <div>
                    <div>
                      <div className={s.cardHeader}>
                        <div className={s.title}> {this.getModalComponent()} </div>
                      </div>
                      {this.props.id === 'studentsListCard' &&
                        <div className={s.studentSearchContainer} data-test-id="performance-by-student-search-bar">
                          <input
                            className={s.studentSearchInput}
                            type="text"
                            placeholder="Search by Student Name"
                            value={this.state.filterTerm}
                            onChange={this.handleFilterChange}
                          />
                          {
                            this.state.filterTerm
                              ? <MLIcon
                                onClick={() => this.handleFilterChange({ target: { value: '' } })}
                                className={s.resetSearchIcon}
                                type="x"
                                viewBox="0 0 24 24"
                                role="presentation"
                              />
                              : <MLIcon
                                className={s.studentSearchIcon}
                                type="search"
                                viewBox="0 0 24 24"
                                role="presentation"
                              />
                          }
                        </div>
                      }
                    </div>
                    <Table
                      className={s.tableCustomStyle}
                      data={this.state.tablePaginated}
                      columns={this.state.tableColumns}
                      styling={this.state.tableStyle}
                      ruled
                      sortable
                      autosort={false}
                      onSortedChange={this.tableSort}
                      sortColumn={this.state.sortBy}
                      sortDirection={this.state.direction}
                      minWidth={this.props.tableMinWidth}
                      caretColor={this.props.caretColor}
                    />
                    {!this.state.filterTerm && (this.state.tableData.length > this.state.pageSize) &&
                      this.getPaginationComponent(7)
                    }
                  </div>
            ) : (
              <div className={s.miniTableContainer} ref={this.refContainer}>
                <div className={s.cardHeader}>
                  {this.getModalComponent()}
                </div>
                <MiniTable
                  className={s.miniTableCustomStyle}
                  data={this.state.tablePaginated}
                  columns={this.miniTableColumns()}
                  styling={this.state.tableStyle}
                  sortable
                  autosort={false}
                  onSortedChange={this.tableSort}
                  sortColumn={this.state.sortBy}
                  sortDirection={this.state.direction}
                  minWidth={320}
                  onColumnChange={this.adjustDropDowns}
                  caretColor={this.props.caretColor}
                />
                {(this.state.tableData.length > this.state.pageSize) &&
                  this.getPaginationComponent(0)
                }
              </div>
            )
            )
          }
        </Media>
        }
        {!loading && (!this.state.tableData ||
          this.state.tableData.length === 0) &&
          this.props.nullState &&
          !this.state.filterTerm &&
          <div>
            <div className={s.nullState}>
              {this.props.nullState}
            </div>
          </div>
        }
        {loading &&
        <div className={s.spinnerContainer}>
          <Spinner className={s.spinner} />
        </div>
      }
      </CollapsibleCard>
    );
  }
}

function mapStateToProps(state) {
  return {
    course: state.courses.course,
  };
}

export default connect(mapStateToProps)(PaginatedTable);
